import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import CustomerApp from "@/pages/CustomerApp";
import CustomerOrders from "@/pages/CustomerOrders";
import CustomerProfile from "@/pages/CustomerProfile";
import POSSystem from "@/pages/POSSystem";
import POSLogin from "@/pages/POSLogin";
import KitchenDisplay from "@/pages/KitchenDisplay";
import KitchenLogin from "@/pages/KitchenLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import OrderTracking from "@/pages/OrderTracking";
import RoleSwitcher from "@/pages/RoleSwitcher";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<CustomerApp />} />
            <Route path="/orders" element={<CustomerOrders />} />
            <Route path="/profile" element={<CustomerProfile />} />
            <Route path="/track/:orderId" element={<OrderTracking />} />
            
            {/* Preview/Navigation Page - Shows all systems */}
            <Route path="/preview" element={<RoleSwitcher />} />
            <Route path="/staff" element={<RoleSwitcher />} />
            
            {/* Staff Login Routes */}
            <Route path="/pos/login" element={<POSLogin />} />
            <Route path="/kitchen/login" element={<KitchenLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected Staff Routes */}
            <Route
              path="/pos"
              element={
                <ProtectedRoute role="pos" loginPath="/pos/login">
                  <POSSystem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kitchen"
              element={
                <ProtectedRoute role="kitchen" loginPath="/kitchen/login">
                  <KitchenDisplay />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin" loginPath="/admin/login">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </AuthProvider>
  );
}

export default App;
